module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/glass-martini-3de3fb012f417822b3069f0b7ffc9a53.svg";